import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { Provider } from 'react-redux'
import { createStore, combineReducers } from 'redux';
import { reducer as jPlayers } from 'react-jplayer';
const store = createStore(combineReducers({ jPlayers }));

ReactDOM.render((

  <Provider store={store}>
    <App />
  </Provider>
)
  ,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
